




























import { AppHeading, AppPicture, AppText } from '@/uikit';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import { Cancellation } from '@/pages/profile/blocks/cards/components';

export default {
  components: {
    Cancellation,
    AppText,
    AppPicture,
    AppHeading,
    AppButtonNew,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    linkToVacancy() {
      return {
        name: 'vacancy',
        params: { id: this.item.vacancy_id },
      };
    },
  },

  data() {
    return {
      inTheProcessOfClosing: false,
    };
  },

  methods: {
    startCancel() {
      this.inTheProcessOfClosing = true;
    },
    stopCancel() {
      this.inTheProcessOfClosing = false;
    },
    cancel(id) {
      this.$emit('cancel', id);
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/FeedbackCard/FeedbackCard.vue